import { render } from "./navigation-menu-edit.vue?vue&type=template&id=6c42b188&scoped=true"
import script from "./navigation-menu-edit.vue?vue&type=script&lang=js"
export * from "./navigation-menu-edit.vue?vue&type=script&lang=js"

import "./navigation-menu-edit.vue?vue&type=style&index=0&id=6c42b188&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c42b188"]])

export default __exports__